export const unit = (value, cast) => {
	if (cast != null) {
		return `${value}${cast}`;
	} else if (typeof value === 'number') {
		return `${value}px`;
	}

	return value;
};
